/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as NewRouteImport } from './routes/new'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ConversationsConversationIdRouteImport } from './routes/conversations.$conversationId'
import { Route as ConversationsViewConversationIdRouteImport } from './routes/conversations.view.$conversationId'

const NewRoute = NewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ConversationsConversationIdRoute =
  ConversationsConversationIdRouteImport.update({
    id: '/conversations/$conversationId',
    path: '/conversations/$conversationId',
    getParentRoute: () => rootRouteImport,
  } as any)
const ConversationsViewConversationIdRoute =
  ConversationsViewConversationIdRouteImport.update({
    id: '/conversations/view/$conversationId',
    path: '/conversations/view/$conversationId',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/new': typeof NewRoute
  '/conversations/$conversationId': typeof ConversationsConversationIdRoute
  '/conversations/view/$conversationId': typeof ConversationsViewConversationIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/new': typeof NewRoute
  '/conversations/$conversationId': typeof ConversationsConversationIdRoute
  '/conversations/view/$conversationId': typeof ConversationsViewConversationIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/new': typeof NewRoute
  '/conversations/$conversationId': typeof ConversationsConversationIdRoute
  '/conversations/view/$conversationId': typeof ConversationsViewConversationIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/new'
    | '/conversations/$conversationId'
    | '/conversations/view/$conversationId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/new'
    | '/conversations/$conversationId'
    | '/conversations/view/$conversationId'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/new'
    | '/conversations/$conversationId'
    | '/conversations/view/$conversationId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  NewRoute: typeof NewRoute
  ConversationsConversationIdRoute: typeof ConversationsConversationIdRoute
  ConversationsViewConversationIdRoute: typeof ConversationsViewConversationIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/new': {
      id: '/new'
      path: '/new'
      fullPath: '/new'
      preLoaderRoute: typeof NewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/conversations/$conversationId': {
      id: '/conversations/$conversationId'
      path: '/conversations/$conversationId'
      fullPath: '/conversations/$conversationId'
      preLoaderRoute: typeof ConversationsConversationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/conversations/view/$conversationId': {
      id: '/conversations/view/$conversationId'
      path: '/conversations/view/$conversationId'
      fullPath: '/conversations/view/$conversationId'
      preLoaderRoute: typeof ConversationsViewConversationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  NewRoute: NewRoute,
  ConversationsConversationIdRoute: ConversationsConversationIdRoute,
  ConversationsViewConversationIdRoute: ConversationsViewConversationIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
